/* nbourhood map poster - ONE source of truth for the map look and the sheet geometry.
   Used by the builder (sections/nb-custom-map.liquid, inlined) AND by the print render
   service (render-service/, vendored copy) so preview and 300 DPI print file are the same code.
   Version: bump NB_MAP_STYLE_VERSION when anything visual changes. */
(function(root){
  var VERSION='2026-09-04.1';
  /* Posterly's 12 combos (line / fill / background) */
  var KOMBOS={
    'Grey':    {vej:'#AEAEAE',vand:'#EAE7E2',bg:'#F9F9F6'},
    'Black':   {vej:'#333333',vand:'#F0EEEA',bg:'#FAFAF8'},
    'Blues':   {vej:'#6D8697',vand:'#99ABB7',bg:'#E5E1D5'},
    'Pepper':  {vej:'#211C1A',vand:'#CDBCAE',bg:'#E6E4DD'},
    'Olive':   {vej:'#E7E1D3',vand:'#6C7B7D',bg:'#969D95'},
    'Beige':   {vej:'#D6C8AF',vand:'#E0D6C4',bg:'#F5F0EA'},
    'Espresso':{vej:'#EAE4D9',vand:'#F7F3EC',bg:'#A29C93'},
    'Moonlit': {vej:'#2B3955',vand:'#F2EEE6',bg:'#C5CECA'},
    'Moss':    {vej:'#E5EFE5',vand:'#034D44',bg:'#729C92'},
    'Sky':     {vej:'#F2D2C3',vand:'#97B4CD',bg:'#F2ECE2'},
    'Midnight':{vej:'#FFFFFF',vand:'#F6F5F2',bg:'#333333'},
    'Graphite':{vej:'#686868',vand:'#F6F6F6',bg:'#E9E9E9'}
  };
  /* Sheet: height 2000 units, width from Posterly's canvas list; map = W-160 x H-420 */
  var KANON={'8x10':1600,'11x14':1572,'27x35':1543,'21x30':1400,'30x40':1500,'40x50':1600,'45x60':1500,'50x70':1428,'60x90':1334,'70x100':1400};
  var GEO={margin:80,textZone:340,cityTop:290,cityH:90,cityBase:77,subTop:160,subH:50,subBase:34,cityFont:90,subFont:25,subLs:0.28,subWs:0.5,cityMinFont:22,subMinFont:10};
  /* Shopify oversaetter stoerrelses-etiketten pr. marked (DK ser "27x35 cm" for varianten "11x14 in").
     Den FYSISKE stoerrelse er tommer (print-systemets format), saa alt normaliseres til inch-noeglen. */
  var CM_TIL_IN={'21x30':'8x10','27x35':'11x14','30x40':'12x16','40x50':'16x20','45x60':'18x24','50x70':'20x28','60x90':'24x36','70x100':'28x40'};
  var TOMMER={'8x10':10,'11x14':14,'12x16':16,'16x20':20,'18x24':24,'20x28':28,'24x36':36,'28x40':40};
  function parseSize(size){
    var str=String(size||'');
    /* Review 22/9 (BLOCKER A-lande): decimaler, saa "A3 (29.7x42 cm)" ikke laeses som 7x42; bare "A3" -> ISO-maal */
    var ISO={A4:[21,29.7],A3:[29.7,42],A2:[42,59.4],A1:[59.4,84.1]};
    var m=str.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    var iso=!m&&str.match(/\bA([1-4])\b/);
    if(iso){var ip=ISO['A'+iso[1]];m=[null,String(ip[0]),String(ip[1])];str+=' cm';}
    var a=m?parseFloat(String(m[1]).replace(',','.')):8, b=m?parseFloat(String(m[2]).replace(',','.')):10;
    var lille=Math.min(a,b)||8, stor=Math.max(a,b)||10, key=lille+'x'+stor;
    if(/cm/i.test(str)&&CM_TIL_IN[key]){key=CM_TIL_IN[key];var q=key.split('x');lille=+q[0];stor=+q[1];}
    return {lille:lille, stor:stor, key:key, longInches:TOMMER[key]||(/cm/i.test(str)?Math.round(stor/2.54*10)/10:stor)};
  }
  function canvasDims(size,horiz){
    var s=parseSize(size);
    var kort=KANON[s.key]||Math.round(2000*s.lille/s.stor);
    return horiz?{W:2000,H:kort}:{W:kort,H:2000};
  }
  function mapBox(dims){return {x:GEO.margin,y:GEO.margin,w:dims.W-2*GEO.margin,h:dims.H-GEO.margin-GEO.textZone};}
  function mix(pal,a){return '#'+[1,3,5].map(function(i){var L=parseInt(pal.vej.substr(i,2),16),B=parseInt(pal.bg.substr(i,2),16);var v=Math.round(a*L+(1-a)*B);return('0'+v.toString(16)).slice(-2)}).join('');}
  /* Restyle an OpenFreeMap "positron" MapLibre map to the poster look.
     cssW = css-px width of the WHOLE map area the widths are tuned for (tiles pass the full width). */
  function styleTilPrint(m,pal,cssW){
    if(!m||!m.getStyle)return;
    pal=pal||KOMBOS.Grey;
    var wood=mix(pal,.2),bygn=mix(pal,.25),minorLav=mix(pal,.35),tunnelF=mix(pal,.75),railF=mix(pal,.85);
    if(!cssW){try{cssW=m.getCanvas().clientWidth;}catch(e){}}
    if(!cssW)cssW=1440;
    var k=cssW/404, D=Math.log(k)/Math.LN2;
    function w(base,stops){var e=['interpolate',['exponential',base],['zoom']];stops.forEach(function(st){e.push(st[0]+D,st[1]*k);});return e;}
    function lin(stops){var e=['interpolate',['linear'],['zoom']];stops.forEach(function(st){e.push(st[0]+D,st[1]);});return e;}
    var W={
      major:['interpolate',['exponential',1.4],['zoom'],6+D,0.5*k,20+D,['match',['get','class'],['trunk','primary'],30*k,20*k]],
      motorway:w(1.4,[[8,1],[16,10]]),
      minor:w(1.55,[[4,0.25],[20,30]]),
      path:w(1.55,[[4,0.25],[20,10]]),
      waterway:w(1.4,[[8,1],[20,8]]),
      pier:w(1.2,[[15,1],[17,4]]),
      rail:1*k
    };
    (m.getStyle().layers||[]).forEach(function(l){
      try{
        var id=l.id, sl=(l['source-layer']||'').toLowerCase(), navn=(id+' '+sl).toLowerCase();
        var P=function(prop,v){m.setPaintProperty(id,prop,v);};
        var skjul=function(){m.setLayoutProperty(id,'visibility','none');};
        if(l.type==='symbol'){skjul();return;}
        if(l.type==='background'){P('background-color',pal.bg);return;}
        if(/casing|dashline|aeroway|boundary|admin/.test(navn)){skjul();return;}
        if(l.type==='fill'){
          if(sl==='water'){P('fill-color',pal.vand);return;}
          if(sl==='landcover'&&/wood/.test(id)){P('fill-color',wood);P('fill-opacity',lin([[8,.6],[22,1]]));return;}
          if(sl==='building'){P('fill-color',bygn);P('fill-outline-color',bygn);P('fill-opacity',lin([[13,0],[15,1]]));return;}
          if(sl==='transportation'){P('fill-color',pal.vej);if(/bridge/.test(id))P('fill-opacity',.5);return;}
          P('fill-color',pal.bg);return;
        }
        if(l.type==='line'){
          if(sl==='waterway'){P('line-color',pal.vand);P('line-width',W.waterway);return;}
          if(/rail|transit/.test(navn)){P('line-color',railF);P('line-width',W.rail);P('line-opacity',lin([[11,0],[16,1]]));return;}
          if(/pier/.test(id)){P('line-color',pal.vej);P('line-width',W.pier);return;}
          if(/tunnel/.test(id)){P('line-color',tunnelF);P('line-width',/motorway|major|primary|trunk/.test(id)?W.motorway:W.minor);P('line-dasharray',/minor/.test(id)?[0.36,0.18]:[0.28,0.14]);return;}
          if(/path|track|footway|cycleway/.test(id)){P('line-color',pal.vej);P('line-width',W.path);P('line-dasharray',[1,1]);return;}
          if(/motorway/.test(id)){P('line-color',pal.vej);P('line-width',W.motorway);return;}
          if(/minor|service/.test(id)){P('line-color',['step',['zoom'],minorLav,11+D,pal.vej]);P('line-width',W.minor);return;}
          P('line-color',pal.vej);P('line-width',W.major);return;
        }
      }catch(e){}
    });
  }
  /* Draw the finished poster: white sheet, map, city + subtitle. S = px per sheet unit.
     mapCanvas must be mapBox(dims).w*S x mapBox(dims).h*S px. Fonts must be loaded first. */
  function tegnPlakat(pc,o){
    var dims=o.dims, S=o.S, box=mapBox(dims);
    pc.width=Math.round(dims.W*S);pc.height=Math.round(dims.H*S);
    var ctx=pc.getContext('2d');
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,pc.width,pc.height);
    var mapW=Math.round(box.w*S), mapH=Math.round(box.h*S);
    ctx.drawImage(o.mapCanvas,box.x*S,box.y*S,mapW,mapH);
    var cityY=(dims.H-GEO.cityTop)+GEO.cityBase, subY=(dims.H-GEO.subTop)+GEO.subBase;
    ctx.textAlign='center';ctx.fillStyle='#000000';
    var cityTekst=(o.head||'').trim().toUpperCase();
    try{ctx.letterSpacing='0px';}catch(e){}
    var fs=GEO.cityFont;
    do{
      ctx.font=(fs*S)+'px "Trend Sans One", sans-serif';
      if(ctx.measureText(cityTekst).width<=mapW||fs<=GEO.cityMinFont)break;
      fs-=2;
    }while(true);
    ctx.fillText(cityTekst,pc.width/2,cityY*S);
    ctx.fillStyle='#343434';
    var subTekst=(o.sub||'').trim().toUpperCase();
    /* Subtitle auto-fit (same rule as the preview): shrink until it fits the map width, floor subMinFont.
       Width is measured per glyph + spacing so it is identical with and without ctx.letterSpacing. */
    try{ctx.letterSpacing='0px';ctx.wordSpacing='0px';}catch(e){}
    var subFs=GEO.subFont;
    var subMaal=function(f){ctx.font=(f*S)+'px "GarnetCapitals", sans-serif';var ls=GEO.subLs*f*S,ws=GEO.subWs*f*S,w=0,j;for(j=0;j<subTekst.length;j++){w+=ctx.measureText(subTekst[j]).width;if(j<subTekst.length-1)w+=ls;if(subTekst[j]===' ')w+=ws;}return w;};
    var subW0=subMaal(subFs);
    if(subW0>mapW)subFs=Math.max(GEO.subMinFont,Math.floor(subFs*mapW/subW0*0.99*100)/100);
    var subLs=GEO.subLs*subFs*S, subWs=GEO.subWs*subFs*S;
    ctx.font=(subFs*S)+'px "GarnetCapitals", sans-serif';
    if('letterSpacing' in CanvasRenderingContext2D.prototype){
      ctx.letterSpacing=subLs+'px';ctx.wordSpacing=subWs+'px';
      ctx.fillText(subTekst,pc.width/2+subLs/2,subY*S);
      ctx.letterSpacing='0px';ctx.wordSpacing='0px';
    }else{
      var sx=0,sw=[],i;
      for(i=0;i<subTekst.length;i++){var w=ctx.measureText(subTekst[i]).width;sw.push(w);sx+=w;if(i<subTekst.length-1)sx+=subLs;if(subTekst[i]===' ')sx+=subWs;}
      var pa=ctx.textAlign;ctx.textAlign='left';
      var x=pc.width/2-sx/2, y=subY*S;
      for(i=0;i<subTekst.length;i++){ctx.fillText(subTekst[i],x,y);x+=sw[i]+subLs;if(subTekst[i]===' ')x+=subWs;}
      ctx.textAlign=pa;
    }
    return {fontPx:fs*S,subFontPx:subFs*S};
  }
  function fontsKlar(S){
    var d=root.document;
    if(!d||!d.fonts||!d.fonts.load)return Promise.resolve();
    return Promise.all([d.fonts.load((GEO.cityFont*S)+'px "Trend Sans One"'),d.fonts.load((GEO.subFont*S)+'px "GarnetCapitals"')]).then(function(){},function(){});
  }
  /* Web Mercator helpers (MapLibre world = 512*2^zoom px) - used by the tiled server render */
  function merc(lng,lat){var s=Math.sin(lat*Math.PI/180);return {x:(lng+180)/360, y:0.5-Math.log((1+s)/(1-s))/(4*Math.PI)};}
  function unmerc(x,y){return {lng:x*360-180, lat:(2*Math.atan(Math.exp((0.5-y)*2*Math.PI))-Math.PI/2)*180/Math.PI};}
  function cameraForBounds(b,cssW,cssH){
    var p0=merc(b.w,b.n), p1=merc(b.e,b.s);
    var zx=Math.log(cssW/((p1.x-p0.x)*512))/Math.LN2, zy=Math.log(cssH/((p1.y-p0.y)*512))/Math.LN2;
    return {zoom:Math.min(zx,zy), cx:(p0.x+p1.x)/2, cy:(p0.y+p1.y)/2};
  }
  root.NbMapStyle={VERSION:VERSION,KOMBOS:KOMBOS,KANON:KANON,CM_TIL_IN:CM_TIL_IN,TOMMER:TOMMER,GEO:GEO,parseSize:parseSize,canvasDims:canvasDims,mapBox:mapBox,mix:mix,styleTilPrint:styleTilPrint,tegnPlakat:tegnPlakat,fontsKlar:fontsKlar,merc:merc,unmerc:unmerc,cameraForBounds:cameraForBounds};
})(typeof window!=='undefined'?window:this);
